import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "mt-6",
  align: "center",
  justify: "space-between"
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }

import { computed, onMounted, ref } from "vue"
import { useUserActions } from "./../../stores/user-actions"
import { useI18n } from "vue-i18n"
import HeaderComponent from "../Header/HeaderComponent.vue"
import { Doctors, SearchParams } from "../../types/index"
import DoctorCard from "../Static/DoctorCard/DoctorCard.vue"
import SearchComponent from "../Landing/Search/SearchComponent.vue"
import router from "@/router"
import FooterComponent from "../Footer/FooterComponent.vue"
import { useMeta } from "vue-meta"


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResults',
  setup(__props) {

const { t } = useI18n()

const doctors = ref<Doctors | undefined>(undefined)
const isLoading = ref<boolean>(false)

const responseStatus = ref({})
const savedSearchParams = ref<SearchParams>()

onMounted(() => {
  onSearching()
})

useMeta(
  computed(() => ({
    title: t("landing-title"),
  }))
)

const onSearching = async (): Promise<void> => {
  const storedSearchParams = localStorage.getItem("searchParams")
  if (storedSearchParams) {
    savedSearchParams.value = JSON.parse(storedSearchParams)

    const userAction = useUserActions()
    isLoading.value = true

    const searchParams: SearchParams = {
      startDate: savedSearchParams.value?.startDate ?? "",
      endDate: savedSearchParams.value?.startDate ?? "",
      latitude: savedSearchParams.value?.latitude ?? 0,
      longitude: savedSearchParams.value?.longitude ?? 0,
      specialty: savedSearchParams.value?.specialty ?? "",
      type: savedSearchParams.value?.type ?? "",
      hospitalId: savedSearchParams.value?.hospitalId ?? "",
      department: savedSearchParams.value?.department ?? "",
    }

    const response = await userAction.searchForDoctor(searchParams)
    responseStatus.value = response
    if (response.success) {
      doctors.value = response.result as Doctors
    }
    isLoading.value = false
  } else {
    router.push("/")
  }
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createVNode(_component_request_status, {
      class: "mt-6",
      response: responseStatus.value,
      isLoading: isLoading.value
    }, null, 8, ["response", "isLoading"]),
    _createElementVNode("div", _hoisted_1, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "green"
            })
          ]))
        : _createCommentVNode("", true),
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(SearchComponent, {
              onSearchClicked: onSearching,
              resultsView: true
            }),
            (!isLoading.value)
              ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctors.value, (doctor) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "doctor-card-container",
                        key: doctor._id
                      }, [
                        _createVNode(DoctorCard, { doctor: doctor }, null, 8, ["doctor"])
                      ]))
                    }), 128)),
                    (doctors.value?.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_v_card, {
                            class: "mx-auto",
                            height: "400",
                            image: require('../../assets/drake.jpeg'),
                            "max-width": "500",
                            theme: "dark",
                            title: _ctx.$t('no-doctors')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, { style: {"font-weight":"bold"} }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("no-doctors-text")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["image", "title"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})